import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import { appStore, orgApiStore, saveOrgStore } from "@/hooks";
import { FlexBox, TextButton, TextInput } from "@/components/common";


/**
 * Inputs for editing an organization.
 */
const __default__ = {
  name: "SaveOrganizationInputs",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const editedOrg = computed(() => saveOrgStore.editedOrg);

const loading = computed(() => orgApiStore.saveOrgApiLoading);

/**
 * Saves the edited organization.
 */
function handleSave() {
  orgApiStore.handleSave(editedOrg.value, {
    onSuccess: () => appStore.close("saveOrg"),
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TextInput), {
      modelValue: editedOrg.value.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editedOrg.value.name) = $event)),
      label: "Organization Name",
      hint: "Required",
      "data-cy": "input-org-name"
    }, null, 8, ["modelValue"]),
    _createVNode(_unref(TextInput), {
      modelValue: editedOrg.value.description,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editedOrg.value.description) = $event)),
      label: "Organization Description",
      type: "textarea",
      "data-cy": "input-org-description"
    }, null, 8, ["modelValue"]),
    _createVNode(_unref(FlexBox), {
      "full-width": "",
      justify: "end"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(TextButton), {
          color: "primary",
          label: "Save",
          "data-cy": "button-org-save",
          loading: loading.value,
          onClick: handleSave
        }, null, 8, ["loading"])
      ]),
      _: 1
    })
  ]))
}
}

})